// In EnglishTool/pool/dramaticDevicesPool.js
export const dramaticDevicesPoolsByPlay = {
  "A Midsummer Night’s Dream": [
    {
      passage: "Lord, what fools these mortals be!",
      device: "Soliloquy",
      distractors: ["Monologue", "Aside", "Stage Direction"]
    }
  ],
  "Hamlet": [
    {
      passage: "To be, or not to be: that is the question.",
      device: "Soliloquy",
      distractors: ["Monologue", "Aside", "Stage Direction"]
    }
  ]
  // ...add other plays
};
